// This is generated.  Alter it in blockGroups/formElements/types/Toggle.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      toggleValues,
      defaultValue,
      neutralOption,
      required,
    } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // If neutralOption is set, the toggle has a 3rd state (neither true nor false), so it should NOT be required.
    // Otherwise, respect the required flag from the metadata.
    const effectiveRequired = neutralOption ? false : required;
    const { isRequired, isEditable, isOptional } =
      moduleRegistration.resolveFieldFlags(effectiveRequired, context);

    // Build the boolean schema with toggle-specific metadata
    const booleanOptions = {
      title: title,
      'x-id': id,
      'x-dataType': 'boolean',
      'x-propertyName': propertyName,
      'x-required': isRequired,
      'x-optional': isOptional,
      'x-editable': isEditable,
      'x-toggleValues': toggleValues,
      'x-neutralOption': neutralOption,
    };

    // Add default value if provided
    if (defaultValue !== undefined && defaultValue !== null) {
      booleanOptions.default = defaultValue;
    }

    let toggleSchema = Type.Boolean(booleanOptions);
    if (isOptional) {
      toggleSchema = Type.Optional(toggleSchema);
    }

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: toggleSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('formElements', 'Toggle', module.exports);
